export default __webpack_public_path__ + "static/media/Proses Pembayaran.f7944504.svg";